import { inject, Injectable, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarRef, TextOnlySnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import {
  BehaviorSubject,
  //delay,
  //interval,
  Observable,
  of,
  //startWith,
  Subscription,
  switchMap,
  //timer
} from 'rxjs';
import { WarningDialogComponent } from '@app/report-form/shared/components/warning-dialog/warning-dialog.component';
import { FrConnectionMonitorService, FrConnectionState } from './fr-connection-monitor.service';
import { FrLogService } from './fr-log.service';

@Injectable({
  providedIn: 'root'
})
export class AppService implements OnDestroy {
  public connectionState: FrConnectionState = {
    hasInternetAccess: true,
    //hasNetworkConnection: true
  };
  private connectionState$?: Observable<FrConnectionState>;
  private onlineStatus = new BehaviorSubject<boolean>(false);
  public onlineStatus$: Observable<boolean> = this.onlineStatus.asObservable();
  public updateAvailable = false;

  private connectionMonitorSubsription: Subscription;

  //private installSnackBar: MatSnackBarRef<TextOnlySnackBar> | undefined;

  private swUpdate = inject(SwUpdate);
  private snackbar = inject(MatSnackBar);
  public dialog = inject(MatDialog);
  private router = inject(Router);
  private frConnectionMonitorService = inject(FrConnectionMonitorService);
  private frLogService = inject(FrLogService);

  constructor() {
    //console.log('== AppService create ==');
    this.connectionState$ = this.frConnectionMonitorService.monitor();
    this.connectionMonitorSubsription = this.connectionState$.subscribe({
        next: (monitorState: FrConnectionState) => {
          console.log('Connection state changed: ', monitorState);
          this.connectionState = monitorState;
          this.onlineStatus.next(
            monitorState.hasInternetAccess// && navigator.onLine
          );
        }
      });
  }

  isOnline(): boolean {
    const hasInternetAccess = this.connectionState?.hasInternetAccess ?? true;
    return hasInternetAccess && navigator.onLine;
  }

  notifyOnUpdate(): void {
    this.swUpdate.versionUpdates.subscribe((event) => {
      switch (event.type) {
        case 'VERSION_DETECTED':
          console.log('Update available: ' + event.version.hash);
          this.frLogService.logFrTrace('New app version detected.', { versionHash: event.version.hash });
          this.snackbar.open(`Downloading update...`, undefined, {
            duration: 10000
          });
          break;
        case 'VERSION_READY':
          console.log(
            'Update downloaded: ' +
              event.currentVersion +
              ' => ' +
              event.latestVersion
          );
          this.frLogService.logFrTrace('Update downloaded.', { 
            currentVersion: event.currentVersion, 
            latestVersion: event.latestVersion 
          });
          this.updateAvailable = true;
          this.showSnackBarForUpdate(1);
          break;
        default:
          break;
      }
    });
  }

  showSnackBarForUpdate(showSnackBarRertyCount: number) {
    const snack = this.snackbar.open(
      `New version of this app is available!`,
      `Update now`
    );
    snack
      .onAction()
      .pipe(
        switchMap(() => {
          if (
            this.router.routerState.snapshot.url == '/report-form' ||
            this.router.routerState.snapshot.url.startsWith(
              '/report-form/saved-reports/'
            )
          ) {
            this.dialog
              .open(WarningDialogComponent, {
                data: {
                  type: 'update',
                  title: 'Warning',
                  button: 'Update',
                  message:
                    'Update will refresh the screen. Any unsaved changes will be lost.',
                  cancelButton: 'Cancel'
                }
              })
              .afterClosed()
              .subscribe((res) => {
                if (res == 'canceled') {
                  if (showSnackBarRertyCount < 6) {
                    showSnackBarRertyCount = showSnackBarRertyCount + 1;
                    this.showSnackBarForUpdate(showSnackBarRertyCount);
                  }
                } else {
                  this.frLogService.logFrTrace('Activating the update.');
                  this.swUpdate.activateUpdate().then(() => {
                    this.updateAvailable = false;
                    this.frLogService.logFrTrace('Reload for finish the update.');
                    window.location.reload();
                  });
                }
              });

            return of(false);
          } else {
            return of(true);
          }
        })
      )
      .subscribe((res) => {
        if (res) {
          this.updateAvailable = false;
          this.frLogService.logFrTrace('Reload for finish the update.');
          window.location.reload();
        }
      });
  }

  ngOnDestroy(): void {
    this.connectionMonitorSubsription?.unsubscribe();
  }
}
